import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=b0e29800&scoped=true&lang=pug&"
import script from "./Channel.vue?vue&type=script&lang=ts&"
export * from "./Channel.vue?vue&type=script&lang=ts&"
import style0 from "./Channel.vue?vue&type=style&index=0&id=b0e29800&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e29800",
  null
  
)

export default component.exports